export const MAIN_SITE_NAME = "https://www.truemenu.in/";
export const SITE_NAME = "http://uat.truemenu.in/";
export const SITE_CONTACT = "+91-9922330757";
export const WHATSAPP_URL = "//api.whatsapp.com/send";
export const TINY_CLOUD_KEY = "3krp7qrwdkjk2di8h22eflkq35bojsecjg6gxs1m3ir6hazl";
export const SITE_TITLE = "POS by Truemenu";